import { render, staticRenderFns } from "./WabaSupsisVolumeBasedPricingTierUpdate.vue?vue&type=template&id=4c72b42a&scoped=true"
import script from "./WabaSupsisVolumeBasedPricingTierUpdate.vue?vue&type=script&lang=js"
export * from "./WabaSupsisVolumeBasedPricingTierUpdate.vue?vue&type=script&lang=js"
import style0 from "./WabaSupsisVolumeBasedPricingTierUpdate.vue?vue&type=style&index=0&id=4c72b42a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c72b42a",
  null
  
)

export default component.exports